import Vue from 'vue'
import VueResource from 'vue-resource'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import appConfig from '@/config.js'

import LoginPage from '@/pages/login'
import RegisterPage from '@/pages/register_company'
import CompanyProfilePage from '@/pages/company_profile'
import UsersManagementPage from '@/pages/company_users_management'
import StoresManagementPage from '@/pages/company_stores_management'
import SystemNotificationsPage from '@/pages/company_notifications'
import ListingPage from '@/pages/listing'
import MercadolibrePage from '@/pages/mercadolibre'
import MercadolibreIntegrationPage from '@/pages/profile_meli_integration'
import MercadolibreV2IntegrationPage from '@/pages/profile_meli_v2_integration'
import MercadolibreV2Page from '@/pages/mercadolibre_v2'
import MultivendeIntegrationPage from '@/pages/profile_multivende_integration'
import AperIntegrationPage from '@/pages/profile_aper_integration'
import TiendaNubeIntegrationPage from '@/pages/profile_tn_integration'
import JumpsellerIntegrationPage from '@/pages/profile_jumpseller_integration'
import DacIntegrationPage from '@/pages/profile_dac_integration'
import GlamitIntegrationPage from '@/pages/profile_glamit_integration'
import ShopifyV2IntegrationPage from '@/pages/profile_shopify_v2_integration'
import ShopifyV2RedirectPage from '@/pages/redirect_shopify_v2'
import ProfileEditPage from '@/pages/profile_edit'
import ShopifyRedirectPage from '@/pages/redirect_shopify'
import ProfileChangePasswordPage from '@/pages/profile_change_password'
import IntegrationSettingsPage from '@/pages/integration_settings'
import VtexSettingsPage from '@/pages/vtex_settings'
import ProfileAddressesPage from '@/pages/profile_addresses'
import CompanyIntegrationsPage from '@/pages/company_integrations'
import CompanyInvoicesPage from '@/pages/company_invoices'
import CompanyApiPage from '@/pages/company_api'
import CompanySettingsPage from '@/pages/company_settings'
import ActivityPage from '@/pages/activity'
import NewShippingPage from '@/pages/new'
import NewFoodShippingPage from '@/pages/new_food'
import BulkImportPage from '@/pages/bulk_import'
import ShippingPage from '@/pages/shipping'
import ExternalShippingPage from '@/pages/external_shipping_new'
import PwdResetEmail from '@/pages/password_email'
import PwdReset from '@/pages/password_reset'
import OauthRedirect from '@/pages/oauth_redirect'
import SelfServiceRedirect from '@/pages/self_service_redirect'
import ManifestList from '@/pages/manifests'
import Manifest from '@/pages/manifest-item'
import DownloadFromApi from '@/pages/download_from_api'

import vueAuthInstance from '@/services/auth'

import store from '@/store/index'
import NProgress from 'nprogress'
import { parseOauthState } from '@/common/oauth-state'

Vue.use(VueResource)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/oauth',
      name: 'oauth',
      component: OauthRedirect,
      meta: { auth: false, title: 'OAuth Redirect' }
    },
    {
      path: '/', redirect: '/search'
    },
    {
      path: '/download/:url',
      name: 'downloadFromApiUrl',
      component: DownloadFromApi,
      meta: { auth: true, title: 'Download' },
      props: true
    },
    {
      path: '/download/:url/:badLinkPart2/:badLinkPart3',
      name: 'downloadFromApiUrlRedirect',
      component: DownloadFromApi,
      meta: { auth: true, title: 'Download' },
      props: true
    },
    {
      path: '/download',
      name: 'downloadFromApiQuerystring',
      component: DownloadFromApi,
      meta: { auth: true, title: 'Download' }
    },
    {
      path: '/manifests',
      name: 'manifests',
      component: ManifestList,
      meta: { auth: true, title: 'Listing' }
    },
    {
      path: '/manifests/:id',
      name: 'manifests-item',
      component: Manifest,
      props: true,
      meta: { auth: true, title: 'Manifests' }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { auth: false, title: 'Log in to your account' }
    },
    {
      path: '/register',
      name: 'register',
      component: RegisterPage,
      meta: { auth: false, title: 'Sign up for new account' }
    },
    {
      path: '/company/profile',
      name: 'company-profile',
      component: CompanyProfilePage,
      meta: { auth: true, title: 'Company Profile' }
    },
    {
      path: '/company/users',
      name: 'users',
      component: UsersManagementPage,
      meta: { auth: true, title: 'Users Management' }
    },
    {
      path: '/company/stores',
      name: 'stores',
      component: StoresManagementPage,
      meta: { auth: true, title: 'Stores Management' }
    },
    {
      path: '/company/notifications',
      name: 'system-notifications',
      component: SystemNotificationsPage,
      meta: { auth: true, title: 'System Notifications' }
    },
    {
      path: '/profile/edit',
      name: 'profile-edit',
      component: ProfileEditPage,
      meta: { auth: true, title: 'Edit profile' }
    },
    {
      path: '/profile/change-password',
      name: 'profile-change-password',
      component: ProfileChangePasswordPage,
      meta: { auth: true, title: 'Change Password' }
    },
    {
      path: '/profile/addresses',
      name: 'profile-addresses',
      component: ProfileAddressesPage,
      meta: { auth: true, title: 'Manage Addresses' }
    },
    {
      path: '/company/integrations',
      name: 'company-integrations',
      component: CompanyIntegrationsPage,
      meta: { auth: true, title: 'Manage Integrations' }
    },
    {
      path: '/profile/integrations/:slug',
      name: 'integration-settings',
      component: IntegrationSettingsPage,
      meta: { auth: true, title: 'Integration settings' }
    },
    {
      path: '/profile/mercadolibre/integration',
      name: 'profile-mercadolibre-integrations',
      component: MercadolibreIntegrationPage,
      meta: { auth: true, title: 'Mercadolibre Integration' }
    },
    {
      path: '/profile/meli-v2/integration',
      name: 'profile-meli-v2-integrations',
      component: MercadolibreV2IntegrationPage,
      meta: { auth: true, title: 'Mercado Libre v2 Integration' }
    },
    {
      path: '/mercadolibre-v2',
      name: 'mercadolibre-v2',
      component: MercadolibreV2Page,
      meta: { auth: true, title: 'Mercado Libre v2' }
    },
    {
      path: '/profile/tienda-nube/integration',
      name: 'profile-tiendaNube-integrations',
      component: TiendaNubeIntegrationPage,
      meta: { auth: true, title: 'Tiendanube Integration' }
    },
    {
      path: '/profile/jumpseller/integration',
      name: 'profile-jumpseller-integrations',
      component: JumpsellerIntegrationPage,
      meta: { auth: true, title: 'Jumpseller Integration' }
    },
    {
      path: '/profile/multivende/integration',
      name: 'profile-multivende-integrations',
      component: MultivendeIntegrationPage,
      meta: { auth: true, title: 'Multivende Integration' }
    },
    {
      path: '/profile/dac/integration',
      name: 'profile-dac-integrations',
      component: DacIntegrationPage,
      meta: { auth: true, title: 'Dac Integration' }
    },
    {
      path: '/profile/aper/integration',
      name: 'profile-aper-integrations',
      component: AperIntegrationPage,
      meta: { auth: true, title: 'Aper Integration' }
    },
    {
      path: '/profile/glamit/integration',
      name: 'profile-glamit-integrations',
      component: GlamitIntegrationPage,
      meta: { auth: true, title: 'Glamit Integration' }
    },
    {
      path: '/shopify-v2/:action',
      name: 'shopify-v2-redirect',
      component: ShopifyV2RedirectPage,
      meta: { auth: false, title: 'Shopify Redirect' }
    },
    {
      path: '/vtex/settings',
      name: 'vtex-settings',
      component: VtexSettingsPage,
      meta: { auth: false, title: 'Vtex Settings' }
    },
    {
      path: '/shopify/:action',
      name: 'shopify-redirect',
      component: ShopifyRedirectPage,
      meta: { auth: false, title: 'Shopify Redirect' }
    },
    {
      path: '/profile/shopify-v2/integration',
      name: 'profile-shopify-v2-integrations',
      component: ShopifyV2IntegrationPage,
      meta: { auth: true, title: 'Shopify v2 Integration' }
    },
    {
      path: '/company/invoices',
      name: 'company-invoices',
      component: CompanyInvoicesPage,
      meta: { auth: true, title: 'View Invoices' }
    },
    {
      path: '/company/api',
      name: 'company-api',
      component: CompanyApiPage,
      meta: { auth: true, title: 'Manage API Webhook' }
    },
    {
      path: '/company/settings',
      name: 'company-settings',
      component: CompanySettingsPage,
      meta: { auth: true, title: 'Manage Company Settings' }
    },
    {
      path: '/activity',
      name: 'activity',
      component: ActivityPage,
      meta: { auth: true, title: 'Listing' }
    },
    {
      path: '/ongoing',
      name: 'ongoing',
      component: ListingPage,
      meta: { auth: true, title: 'Listing' },
      props: { type: 'ongoing' }
    },
    {
      path: '/scheduled',
      name: 'scheduled',
      component: ListingPage,
      meta: { auth: true, title: 'Listing' },
      props: { type: 'scheduled' }
    },
    {
      path: '/history',
      name: 'history',
      component: ListingPage,
      meta: { auth: true, title: 'Listing' },
      props: { type: 'history' }
    },
    {
      path: '/drafts',
      name: 'drafts',
      component: ListingPage,
      meta: { auth: true, title: 'Listing' },
      props: { type: 'drafts' }
    },
    {
      path: '/ready',
      name: 'ready',
      component: ListingPage,
      meta: { auth: true, title: 'Listing' },
      props: { type: 'ready' }
    },
    {
      path: '/incidences',
      name: 'incidences',
      component: ListingPage,
      meta: { auth: true, title: 'Listing' },
      props: { type: 'incidences' }
    },
    {
      path: '/toreview',
      name: 'toreview',
      component: ListingPage,
      meta: { auth: true, title: 'Listing' },
      props: { type: 'toreview' }
    },
    {
      path: '/search',
      name: 'search',
      component: ListingPage,
      meta: { auth: true, title: 'Search' },
      props: { type: 'search' }
    },
    {
      path: '/mercadolibre/',
      name: 'mercadolibre',
      component: MercadolibrePage,
      meta: { auth: true, title: 'Mercadolibre' },
      props: { type: 'mercadolibre' }
    },
    {
      path: '/new',
      name: 'new',
      component: NewShippingPage,
      meta: { auth: true, title: 'New shipping' }
    },
    {
      path: '/new/food',
      name: 'new-food',
      component: NewFoodShippingPage,
      meta: { auth: true, title: 'New Food shipping' }
    },
    {
      path: '/bulk-import',
      name: 'bulk-import',
      component: BulkImportPage,
      meta: { auth: true, title: 'Bulk Import Shippings' }
    },
    {
      name: 'shipping',
      path: '/shippings/:id',
      component: ShippingPage,
      props: true,
      meta: { auth: true, title: 'A shipping' }
    },
    {
      name: 'external_shipping',
      path: '/external',
      component: ExternalShippingPage,
      props: false,
      meta: { auth: false, title: 'A shipping' }
    },
    {
      name: 'external_shipping_unsubscribe_with_hash',
      path: '/external/:id/unsubscribe',
      component: ExternalShippingPage,
      props: true,
      meta: { auth: false, title: 'A shipping', unsubscribe: true }
    },
    {
      name: 'external_shipping_with_hash_hack',
      path: '/external/external/:id',
      component: ExternalShippingPage,
      props: true,
      meta: { auth: false, title: 'A shipping' }
    },
    {
      name: 'external_shipping_with_hash',
      path: '/external/:id',
      component: ExternalShippingPage,
      props: true,
      meta: { auth: false, title: 'A shipping' }
    },
    {
      path: '/password/reset',
      name: 'password_email',
      component: PwdResetEmail,
      meta: { auth: false, title: 'Forgot Password' }
    },
    {
      name: 'password_reset',
      path: '/password/reset/:token',
      component: PwdReset,
      props: true,
      meta: { auth: false, title: 'Reset Password' }
    },
    {
      // from Self Service Company creation email
      name: 'SelfServiceRedirect',
      path: '/users/:uid/companies/:cid/confirm',
      component: SelfServiceRedirect,
      props: true,
      meta: { auth: false, title: 'Confirm Redirect' }
    }
  ]
})

// loadBar start
router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
    NProgress.set(0.1)
    NProgress.set(0.4)
  }
  next()
})
// loadBar end
router.afterEach((to, from) => {
  setTimeout(() => NProgress.done(), 500)
})

router.beforeResolve(function (to, from, next) {
  const { source, hostname } = parseOauthState(to.query.state)
  const isRedirectToSaaS = hostname && window.location.hostname !== hostname

  if (isRedirectToSaaS) {
    const params = { ...to.query }
    delete params.state
    if (source) params.source = source
    const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&') || ''
    window.location.href = `https://${hostname}${to.path}/?${queryString}`
  } else if (!vueAuthInstance.isAuthenticated() && to.path.includes('/shopify/create-shipping')) {
    const headers = { 'x-api-key': appConfig.integrations.ecommerce.header }
    Vue.http.get(appConfig.integrations.ecommerce.baseUrl + 'shopify/posible-domain', {
      headers,
      params: { storeName: to.query.shop }
    })
      .then(response => {
        const domainValue = response.body && response.body.domain
        if (!domainValue) return
        const newDomain = String(domainValue).replace(/https?:\/\//, '').replace(/\/$/, '')
        if (newDomain !== window.location.hostname) {
          const queryString = Object.keys(to.query).map(key => `${key}=${to.query[key]}`).join('&') || ''
          window.location.href = `https://${newDomain}${to.path}${queryString ? '?' + queryString : ''}`
        }
      })
      .catch(error => {
        console.error('Error fetching possible domain:', error)
      })
  }

  if (to.meta && to.meta.auth === true) {
    if (to.meta.auth) {
      if (vueAuthInstance.isAuthenticated()) {
        next()
      } else {
        store.commit('setUid', null)
        store.commit('setEmail', null)
        store.commit('setProfile', {})
        router.push({ name: 'login', query: { redirect: to.fullPath } })
      }
    } else {
      if (to.name.indexOf('external') !== -1 || to.name.indexOf('SelfServiceRedirect') !== -1) {
        next()
      } else if (vueAuthInstance.isAuthenticated()) {
        router.push({ name: 'search' })
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

if (appConfig.GA_ACCOUNT) {
  Vue.use(VueAnalytics, {
    id: appConfig.GA_ACCOUNT,
    router
  })
}

export default router
